/**
 * Client-side flag + audience gate for the Guided Learning card-review (GL-4b)
 * and due-queue (GL-5b) surfaces. Single mount condition so the two surfaces can
 * never drift, mirroring the Audio Mode / GL-3 pattern.
 *
 * Flags (both required, fail-closed):
 *   REACT_APP_GL_ENABLED   = "true" master switch; anything else => off.
 *   REACT_APP_GL_AUDIENCE  = off|cohort|tutors|all, case-insensitive. ABSENT and
 *     any unrecognized value resolve to "off" (a NEW surface fails closed, like
 *     Audio Mode — deliberately unlike the more-like-this ABSENT="all" parse).
 *
 * Audience (client is UX-only; the server enforces its own gate on the /gl
 * endpoints and stays authoritative):
 *   all    => everyone. tutors => ROLE_TUTOR/ROLE_ADMIN. cohort => any
 *   authenticated user (a stored role); server verifies real membership.
 */
const readRole = () =>
  typeof window !== "undefined" && window.localStorage
    ? window.localStorage.getItem("role")
    : null;

export const glAudienceAllows = () => {
  const raw = process.env.REACT_APP_GL_AUDIENCE;
  if (raw === undefined || raw === null) {
    return false; // absent -> off (fail-closed)
  }
  const value = String(raw).trim().toLowerCase();
  if (value === "all") {
    return true;
  }
  if (value === "tutors") {
    const role = readRole();
    return role === "ROLE_TUTOR" || role === "ROLE_ADMIN";
  }
  if (value === "cohort") {
    return !!readRole();
  }
  return false; // "off" and anything unrecognized fail closed
};

/** Master flag AND audience — the single mount condition for GL-4b/5b surfaces. */
export const glAvailable = () =>
  process.env.REACT_APP_GL_ENABLED === "true" && glAudienceAllows();
